export const BASE_URL = 'settings';
